module.exports = __webpack_public_path__ + "static/img/faatili-felix.79551d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faatili-felix.jpg
// module id = XnCU
// module chunks = 0